module.exports = __webpack_public_path__ + "static/media/circle.0bcf154d.png";